import { useEffect } from "react";
import { css } from "../../components/SKT";
import { SKTAcceptTermsAndConditions } from "../../components/SKTAcceptTermsAndConditions";
import { SKTAction } from "../../components/SKTAction";
import { SKTAddressField } from "../../components/SKTAddressField";
import { SKTBaseComponent } from "../../components/SKTBaseComponent";
import { SKTButton } from "../../components/SKTButton";
import { SKTCheckbox } from "../../components/SKTCheckbox";
import { SKTForm } from "../../components/SKTForm";
import { SKTInfo } from "../../components/SKTInfo";
import { SKTPanel, SKTPanelBody } from "../../components/SKTPanel";
import {
  SKTRadioButton,
  SKTRadioOption,
} from "../../components/SKTRadioButton";
import { SKTPassword, SKTTextField } from "../../components/SKTTextField";
import { SKTToggle } from "../../components/SKTToggle";
import { useData } from "../../hooks/Data";
import {
  isValidAddress,
  isValidBID,
  isValidEmail,
  isValidName,
  isValidPassword,
  isValidPhone,
  passthru,
  passwordsMatch,
} from "../../utils/validators";

export const RegisterDone = ({ doReturn }) => {
  return (
    <SKTPanel>
      <SKTPanelBody>
        <SKTForm>
          <SKTInfo>
            <h4>Tilin rekisteröinti onnistui!</h4>
            <p>Tervetuloa Suomen Kuljetustilausten asiakkaaksi!</p>
            <p>
              Asiakastunnuksesi on nyt luotu. Ennen kirjautumista, sinun tulee
              vahvistaa sähköpostiosoitteesi. Saat ilmoittamaasi
              sähköpostiosoitteeseen ohjeet, miten tunnuksen saa aktivioitua.
            </p>
            <br />
            <br />
          </SKTInfo>
          <SKTAction
            actionLabel="Kirjautumissivulle &raquo;"
            onClick={doReturn}
            active={true}
            type="btn-success"
          ></SKTAction>
        </SKTForm>
      </SKTPanelBody>
    </SKTPanel>
  );
};

export const RegisterForm = ({ doRegister, registerStatus }) => {
  const data = useData({
    validators: {
      iUsername: isValidEmail,
      iPassword: isValidPassword,
      iPassword2: passwordsMatch,
      iSBID: isValidBID,
      iSZIP: passthru,
      iSName: isValidName,
      iSPhone: isValidPhone,
      iSEmail: isValidEmail,
      iSAddr1: isValidAddress,
      acct_type: passthru,
      accept_tc: passthru,
    },
    defaults: {
      /*
      acct_type: "private",
      iUsername: "test1@kuipeesi.fi",
      iPassword: "foobar42",
      iPassword2: "foobar42",
      iSZIP: "00100 HELSINKI",
      iSName: "Antti Asiakas",
      iSPhone: "0401234567",
      iSEmail: "test1@kuipeesi.fi",
      iSAddr1: "Testikatu 1",
      accept_tc: true,
      */
    },
  });

  return (
    <SKTPanel>
      <SKTPanelBody>
        <SKTForm>
          <SKTInfo>
            <h4>Kirjautumistiedot</h4>
            <p>
              Käyttäjätunnuksesi tulee olemaan sähköpostiosoitteesi. Lähetämme
              tähän sähköpostiosoitteeseen kuittaukset tehdyistä
              kuljetustilauksista, ja välitämme sähköpostiosoitteen myös
              kuljetusliikkeelle mahdollisia lisätietokyselyitä varten.
              Tarkemmat tiedot näiden tietojen käsittelystä löydät
              <a href="/rekisteriseloste/" target="_blank">
                rekisteriselosteesta
              </a>
              .
            </p>
            <p>
              Salasanan tulee olla vähintään 8 merkkiä, ja sisältää vähintään
              yksi kirjain ja yksi numero. Tämän lisäksi erikoismerkkejä voi
              käyttää salasanassa vapaasti.
            </p>
            <SKTToggle
              when={
                registerStatus.status === "fail" &&
                registerStatus.reason === "user_creation"
              }
            >
              <p className={css("error")}>
                Samalla käyttäjätunnuksella on jo olemassa tunnus palvelussa.
                Voit palauttaa unohtuneen salasanan tästä:
                <a href="/palauta-salasana">linkki</a>
              </p>
            </SKTToggle>
            <SKTToggle
              when={
                registerStatus.status === "fail" &&
                registerStatus.reason !== "user_creation"
              }
            >
              <p className={css("error")}>
                Tunnuksen luomisessa tapahtui virhe. Ota yhteyttä
                asiakaspalveluun!
              </p>
            </SKTToggle>
          </SKTInfo>

          <SKTTextField data={data} id="iUsername" label="Sähköpostiosoite" />
          <SKTPassword data={data} id="iPassword" label="Salasana" />
          <SKTPassword data={data} id="iPassword2" label="Salasana uudestaan" />

          <SKTInfo>
            <br />
          </SKTInfo>

          <SKTRadioButton
            id="acct_type"
            data={data}
            singleValue={true}
            label="Olen"
          >
            <SKTRadioOption value="private" label="Yksityishenkilö" />
            <SKTRadioOption value="corporate" label="Yritysasiakas" />
          </SKTRadioButton>

          <SKTAddressField
            data={data}
            prefix="iS"
            corporate={data.get("acct_type") === "corporate"}
          />
          <SKTToggle when={data.get("acct_type") === "corporate"}>
            <SKTTextField
              data={data}
              id="iSBID"
              label="Y-tunnus"
              placeholder="1234567-0"
            />
            <SKTCheckbox
              data={data}
              id="billing_same_as_contact"
              label="Käytä yhteystietoja laskutusosoitteena"
            />
            <SKTToggle when={!data.get("billing_same_as_contact")}>
              <SKTAddressField
                corporate={true}
                data={data}
                prefix="iB"
                label="Laskutusosoite"
              />
            </SKTToggle>
          </SKTToggle>
          <SKTAcceptTermsAndConditions data={data} />
          <SKTAction
            actionLabel="Luo tunnus"
            onClick={() => doRegister(data.values)}
            active={true}
            type="btn-success"
          ></SKTAction>
        </SKTForm>
      </SKTPanelBody>
    </SKTPanel>
  );
};
